import { setActiveRightbarAction as setActiveRightbarOperation } from 'editor/src/store/editorModules/rightbar/slice';

export default setActiveRightbarOperation;
